import { useTranslation } from 'react-i18next';
import { Button, Modal, Switch } from '@teo/components';
import { useState, useEffect, useRef } from 'react';
import { Portal } from '@/components/Portal';
import { UploadFileBox } from '@/components/UploadDropzoneSection/UploadFileBox';

export const DrawIoImportModal = ({ onClose, onInsert }: any) => {
  const [files, setFiles] = useState<any[]>([]);
  const { t } = useTranslation();

  return (
    <Portal root="body">
      <div className="z-10 bg-white">
        <Modal isOpen={true}>
          <Modal.Body>
            <p className="font-semibold">{t('upload_drawio.title')}</p>
            <UploadFileBox files={files} setFiles={setFiles} multiple={false} />
          </Modal.Body>
          <Modal.Footer
            cancelButtonLabel={t('widgets.upload_buttons.cancel_button')}
            onCancel={onClose}
          >
            <div className="flex gap-3">
              <Button
                type="button"
                onClick={() => {
                  onInsert(files[0]);
                }}
              >
                {t('widgets.upload_buttons.insert')}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </Portal>
  );
};
